import request from './base';

export const getUsers = (queryArgs) => {
    return request.fetchList({url: '/students', ...queryArgs});
};

export const getUser = (userId) => {
    return request.getJSON(`/students/${userId}`);
};

export const getUserQuizzingDetails = (userId, queryArgs) => {
    return request.fetchList({url: `/students/${userId}/quizzes`, ...queryArgs});
};

export const prepareUsageReport = (quizId, email, startDate, endDate) => {
    return request.postJSON('/usage_report', {quiz_id:quizId, email:email, start_date:startDate, end_date:endDate});
};